<template>
    <div class="asociacionManual">
        <vuestic-widget header-text="Asociación Manual">
            <form @submit.prevent="asociar">
                <div class="form-group">
                    <div class="input-group">
                        <input-comp :required="true" label="Código Interno" v-model="codigoInterno"/>
                    </div>
                    <div class="input-group">
                        <input-comp :required="true" label="Descripción" v-model="descripcion"/>
                    </div>
                    <div class="input-group">
                        <input-comp :required="true" label="Código Proveedor" v-model="codigoProveedor" />
                    </div>
                    <div class="input-group">
                        <input-comp :required="true" label="Descripción Proveedor" v-model="descripcionProveedor" />
                    </div>
                </div>
                <button type="submit" class="btn btn-micro btn-info">Asociar</button>
            </form>
        </vuestic-widget>
    </div>
</template>

<script>
    import VuesticWidget from "../../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget";
    import InputComp from "../../Componentes_Globales/Input/inputComp";

    export default {
        name: "asociacionManual",
        data(){
            return{
                codigoInterno:'',
                descripcion: '',
                codigoProveedor: '',
                descripcionProveedor: ''
            }
        },
        components: {InputComp, VuesticWidget},
        methods: {
            asociar() {

            }
        }
    }
</script>

<style scoped lang="scss">
    .input-group{
        margin-right: 5px;
    }
</style>
